import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { selectChecklistConfig } from "./checklistSelectors";
import { buildReviewRows, buildSurveyorRows } from "../../utils/reviewAnswerMatcher";

export const selectAnswer = (state: RootState) => state.answer;

export const selectSurveyorAnswers = (state: RootState) => state.answer.surveyorAnswers;

export const selectSurveyorLoading = (state: RootState) => state.answer.surveyorLoading;

export const selectSurveyorError = (state: RootState) => state.answer.surveyorError;

export const selectInspectionsList = (state: RootState) => state.answer.inspections;

export const selectLoadingInspections = (state: RootState) => state.answer.loadingInspections;

export const selectErrorInspections = (state: RootState) => state.answer.errorInspections;

export const selectSelectedInspection = (state: RootState) => state.answer.selectedInspection;

/** The photos captured for this inspection, grouped by question (asset-manager). */
export const selectInspectionImages = (state: RootState) =>
    state.answer.selectedInspection?.images ?? undefined;

/** Session cache of resolved question-image assets, keyed by assetId. */
export const selectResolvedAssets = (state: RootState) => state.answer.resolvedAssets;

export const selectReviewAnswers = (state: RootState) => state.answer.reviewAnswers;

export const selectFailedEdits = (state: RootState) => state.answer.failedEdits;

export const selectFilteredReviewRows = (state: RootState) => state.answer.filteredReviewRows;

/**
 * The Checklist Review table rows: the checklist configuration joined with the
 * review answers, one row per question in checklist order (unanswered included).
 */
export const selectChecklistReviewRows = createSelector(
    selectChecklistConfig,
    selectReviewAnswers,
    // Config and DD-bound answers now come back in the same shape (keyed by the
    // question's identifier — its dataDictionaryId or, for config-driven checklists,
    // its id), so one builder serves both.
    (config, reviewAnswers) => buildReviewRows(config, reviewAnswers)
);

/**
 * The Surveyor Submission tab rows: the checklist configuration
 * joined with the surveyor's original answers from the answers table.
 */
export const selectSurveyorRows = createSelector(
    selectChecklistConfig,
    selectSurveyorAnswers,
    (config, answers) => buildSurveyorRows(config, answers)
);
